import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Sider
import Home from "./pages/Home";
import Workshop from "./pages/Workshop";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Booking from "./pages/Booking";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="relative flex min-h-screen flex-col bg-slate-900 text-white antialiased">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vaerkstedet" element={<Workshop />} />
            <Route path="/vaerksted" element={<Workshop />} />
            <Route path="/service-og-reparation" element={<Services />} />
            <Route path="/vaerkstedet/:slug" element={<ServiceDetail />} />
            <Route path="/service/:slug" element={<ServiceDetail />} />
            <Route path="/online-booking" element={<Booking />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/kontakt" element={<Contact />} />
            {/* Fallback rute */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
